import { selectors } from 'modules/common';
import { loadFirstStartSetup } from 'modules/first-start';
import { useSelector } from 'modules/react-redux';
import { PROFILE_SETUP_EMAIL_PAGE_ID } from 'pages/auth/config';
import { useDispatch } from 'react-redux';
import { routingService } from 'services/routing';
import { useGetInvitations } from 'shared/data/webApp/v2';
import { getPath, Path } from 'urlBuilder';

import { showProfileSetupModule } from '../../actions';

export const useProfileSetupEmailPageData = () => {
    const dispatch = useDispatch();

    const startupData = useSelector(selectors.session.getStartupData);
    const practiceInvitations = useSelector(selectors.practiceInvitations.getPracticeInvitations);

    useGetInvitations({
        onSettled: (data) => {
            const invitations = data?.items || [];

            if (startupData.needsToCompleteSignupWizard || invitations.length || practiceInvitations.length) {
                dispatch(loadFirstStartSetup(invitations));
                dispatch(showProfileSetupModule(PROFILE_SETUP_EMAIL_PAGE_ID));
            } else {
                routingService.replace(getPath(Path.login));
            }
        },
    });
};
